import { render, staticRenderFns } from "./f_info.vue?vue&type=template&id=6d8b7122&scoped=true&"
import script from "./f_info.vue?vue&type=script&lang=js&"
export * from "./f_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b7122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8b7122')) {
      api.createRecord('6d8b7122', component.options)
    } else {
      api.reload('6d8b7122', component.options)
    }
    module.hot.accept("./f_info.vue?vue&type=template&id=6d8b7122&scoped=true&", function () {
      api.rerender('6d8b7122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/f_exchange/f_info.vue"
export default component.exports